'use client';

import { create } from 'zustand';

const DEAL_TYPES = ['rent', 'sale'] as const;
export type DealType = (typeof DEAL_TYPES)[number];

interface DealTypeState {
  dealType: DealType;
  setDealType: (dealType: DealType) => void;
}

export const useDealTypeStore = create<DealTypeState>((set) => ({
  dealType: 'rent',
  setDealType: (dealType) => {
    const normalizedDealType = DEAL_TYPES.includes(dealType) ? dealType : 'rent';
    set({ dealType: normalizedDealType });
  },
}));

export const useGetDealType = () => useDealTypeStore((state) => state.dealType);
export const useSetDealType = () => useDealTypeStore((state) => state.setDealType);
